export function buildStockMap(operaciones = [], ventas = []) {
  const map = {};
  const add = (libroId, libreriaId, delta) => {
    const key = `${String(libroId)}-${String(libreriaId)}`;
    map[key] = (map[key] || 0) + delta;
  };

  operaciones.forEach((o) => {
    const qty = parseInt(o.cantidad, 10) || 0;
    if (o.tipo === "envio") add(o.libroId, o.libreriaId, qty);
    if (o.tipo === "devolucion") add(o.libroId, o.libreriaId, -qty);
  });

  ventas.forEach((v) => {
    const qty = parseInt(v.cantidad, 10) || 0;
    add(v.libroId, v.libreriaId, -qty);
  });

  return map;
}

export function getStockFromMap(stockMap, libroId, libreriaId) {
  return stockMap[`${String(libroId)}-${String(libreriaId)}`] || 0;
}

export function calcularImporteVenta(precio, descuento, cantidad) {
  const base = (Number(precio) || 0) * (parseInt(cantidad, 10) || 0);
  const dto = base * ((Number(descuento) || 0) / 100);
  return base - dto;
}

// Lo que se queda la librería (el "descuento"/porcentaje es la comisión de la librería, no del usuario).
export function calcularImporteLibreria(precio, descuento, cantidad) {
  const base = (Number(precio) || 0) * (parseInt(cantidad, 10) || 0);
  return base * ((Number(descuento) || 0) / 100);
}

// Normaliza el % de la librería sin pisar un 0 legítimo: "" o algo no numérico
// cae al valor por defecto, pero "0" se respeta (bug: `Number(v) || 30` trata 0 como falsy).
export function normalizeDescuento(value, fallback = 30) {
  if (value === "" || value === null || value === undefined) return fallback;
  const num = Number(value);
  return Number.isNaN(num) ? fallback : num;
}

export function buildLibroStockSummaries(libros = [], librerias = [], ventas = [], stockMap = {}) {
  return libros.map((libro) => {
    const enLibrerias = librerias.reduce((acc, libreria) => acc + getStockFromMap(stockMap, libro.id, libreria.id), 0);
    const vendido = ventas
      .filter((v) => String(v.libroId) === String(libro.id))
      .reduce((acc, v) => acc + (parseInt(v.cantidad, 10) || 0), 0);
    const stockTotal = parseInt(libro.stockTotal, 10) || 0;
    return { id: libro.id, titulo: libro.titulo, stockTotal, enLibrerias, vendido, quedan: stockTotal - vendido };
  });
}
